export const handleWhatsAppRedirect = () => {
  window.open("https://wa.me/+919825850501", "_blank");
};
